import { render, staticRenderFns } from "./WardeningPage.vue?vue&type=template&id=24dbf362"
import script from "./WardeningPage.vue?vue&type=script&lang=js"
export * from "./WardeningPage.vue?vue&type=script&lang=js"
import style0 from "./WardeningPage.vue?vue&type=style&index=0&id=24dbf362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports